<script setup lang="ts">
import UserMenuOptions from '~/components/user/user-menu-options.vue';
import { useAuthStore } from '~/stores/auth.store';
const router = useRouter();
const auth = useAuthStore();
onBeforeMount(() => {
  if (!auth.loggedIn) router.push('/');
});
</script>
<template>
  <div v-if="auth.loggedIn" class="flex flex-col md:flex-row relative h-full">
    <div
      class="w-full md:max-w-56 max-w-full bg-layer z-50 sticky top-0 md:border-b-0"
    >
      <UserMenuOptions />
    </div>
    <div
      class="w-full min-h-full overflow-y-auto bg-layer md:bg-base-secondary max-h-[85vh] md:max-h-[75vh] p-0 md:p-4 md:pt-0"
    >
      <slot />
    </div>
  </div>
</template>
